import { render, staticRenderFns } from "./WorkCalendarColumn.vue?vue&type=template&id=6ae3679c&scoped=true"
import script from "./WorkCalendarColumn.vue?vue&type=script&lang=js"
export * from "./WorkCalendarColumn.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendarColumn.vue?vue&type=style&index=0&id=6ae3679c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae3679c",
  null
  
)

export default component.exports